import React, { useEffect, useState } from "react";
import Hero from "../components/home/Hero";
import StatsBar from "../components/home/StatsBar";
import BentoGrid from "../components/home/BentoGrid";
import ShopByRoom from "../components/home/ShopByRoom";
import TrustStrip from "../components/home/TrustStrip";
import HomeownersSection from "../components/home/HomeownersSection";
import ProcessTeaser from "../components/home/ProcessTeaser";
import ComparisonSlider from "../components/home/ComparisonSlider";
import FeaturesShowcase from "../components/home/FeaturesShowcase";
import B2CB2BSplit from "../components/home/B2CB2BSplit";
import BrandsShowcase from "../components/home/BrandsShowcase";
import Testimonials from "../components/home/Testimonials";
import GalleryPreview from "../components/home/GalleryPreview";
import FAQ from "../components/home/FAQ";
import { useBookingModal } from "../contexts/BookingModalContext";

const AUTO_POPUP_DELAY = 7000; // 7 seconds

export default function HomePage() {
  const { openModal } = useBookingModal();
  const [hasTriggered, setHasTriggered] = useState(false);

  const triggerModal = () => {
    if (!hasTriggered) {
      openModal();
      setHasTriggered(true);
    }
  };

  useEffect(() => {
    // Strategy 1: Time-based delay (7 seconds)
    const timeoutId = setTimeout(() => {
      triggerModal();
    }, AUTO_POPUP_DELAY);

    // Strategy 2: Exit intent detection
    const handleMouseLeave = (e) => {
      // Only trigger if mouse leaves from top of viewport (trying to close tab)
      if (e.clientY <= 0 && !hasTriggered) {
        triggerModal();
      }
    };

    // Add event listeners
    document.addEventListener("mouseleave", handleMouseLeave);

    // Cleanup
    return () => {
      clearTimeout(timeoutId);
      document.removeEventListener("mouseleave", handleMouseLeave);
    };
  }, [hasTriggered, openModal]);

  return (
    <>
      <Hero />
      <StatsBar />
      <BentoGrid />
      <ShopByRoom />
      <TrustStrip />
      <HomeownersSection />
      <ProcessTeaser />
      {/* <ComparisonSlider /> */}
      <FeaturesShowcase />
      <B2CB2BSplit />
      <BrandsShowcase />
      <Testimonials />
      <GalleryPreview />
      <FAQ />
    </>
  );
}
